import { render, staticRenderFns } from "./ChartPieStat.vue?vue&type=template&id=23fc4272&scoped=true&"
import script from "./ChartPieStat.vue?vue&type=script&lang=js&"
export * from "./ChartPieStat.vue?vue&type=script&lang=js&"
import style0 from "./ChartPieStat.vue?vue&type=style&index=0&id=23fc4272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc4272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23fc4272')) {
      api.createRecord('23fc4272', component.options)
    } else {
      api.reload('23fc4272', component.options)
    }
    module.hot.accept("./ChartPieStat.vue?vue&type=template&id=23fc4272&scoped=true&", function () {
      api.rerender('23fc4272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/testCaseReport/ChartPieStat.vue"
export default component.exports